import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "text-styles-icon",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.66667 3.125C4.71066 3.125 3.125 4.71066 3.125 6.66667V13.3333C3.125 15.2893 4.71066 16.875 6.66667 16.875H13.3333C15.2893 16.875 16.875 15.2893 16.875 13.3333V6.66667C16.875 4.71066 15.2893 3.125 13.3333 3.125H6.66667ZM1.875 6.66667C1.875 4.0203 4.0203 1.875 6.66667 1.875H13.3333C15.9797 1.875 18.125 4.0203 18.125 6.66667V13.3333C18.125 15.9797 15.9797 18.125 13.3333 18.125H6.66667C4.0203 18.125 1.875 15.9797 1.875 13.3333V6.66667Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.95416 8.10897C6.95416 7.77265 7.22681 7.5 7.56314 7.5H12.4349C12.7713 7.5 13.0439 7.77265 13.0439 8.10897C13.0439 8.4453 12.7713 8.71795 12.4349 8.71795H7.56314C7.22681 8.71795 6.95416 8.4453 6.95416 8.10897Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.99903 7.5C10.3354 7.5 10.608 7.77265 10.608 8.10897V12.5748C10.608 12.9111 10.3354 13.1838 9.99903 13.1838C9.66271 13.1838 9.39006 12.9111 9.39006 12.5748V8.10897C9.39006 7.77265 9.66271 7.5 9.99903 7.5Z"
    }, null, -1)
  ])))
}
export default { render: render }